// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__hdehu","content":"modal_content__-o1lY"};